import { render, staticRenderFns } from "./StmsRejectForm.vue?vue&type=template&id=84ed2606&"
import script from "./StmsRejectForm.vue?vue&type=script&lang=js&"
export * from "./StmsRejectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports